module.exports = __webpack_public_path__ + "static/img/A90.5bba610c.jpg";